var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-card-row"},_vm._l((6),function(index){return _c('div',{key:index,staticClass:"loader-item"},[_c('aha-skeleton-loader',{staticClass:"loader-card"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }